import { colors } from '@material-ui/core';

const backgroundColor = 'rgba(0,0,0,0)';

export const loginFrom = {
  loginFrom: {
    root: {
      '& .MuiTextField-root': {
        color: colors.common.white,
        borderColor: colors.common.white
      },
      '& .MuiInputBase-root': {
        color: colors.common.white,
        borderColor: colors.common.white
      },
    }
  },
  text: {
    primary: colors.common.white,
    secondary: colors.common.white
  },
  card: {
    backgroundColor: backgroundColor,
    overflow: 'visible',
    display: 'flex',
    position: 'relative',
    border: 'none',
    boxShadow: 'none',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%'
    }
  }
}
